import * as types from "../types";

export const updateImage = ({ parentId, parentType, imageType, image }) => {
  const formData = new FormData();

  formData.append(`${parentType}[${imageType}]`, image);

  return {
    type: types.UPDATE_IMAGE,
    request: {
      url: `/${parentType}s/${parentId}/${imageType}`,
      method: "PATCH",
      headers: {
        "Content-Type": "multipart/form-data"
      },
      data: formData
    },
    meta: {
      mutations: {
        [types.GET_EXPERT]: (prevData, newData) => {
          if (parentType === "expert") {
            return { ...prevData, data: newData.data };
          }
          return prevData;
        },
        [types.GET_EXHIBITOR]: (prevData, newData) => {
          if (parentType === "exhibitor") {
            return { ...prevData, data: newData.data };
          }
          return prevData;
        }
      }
    }
  };
};
